module.exports = __webpack_public_path__ + "static/media/betfairLogo.06a599bf.svg";